// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"jo-z","summaryPar":"ko-z","ratingCategories":"lo-z","reviewerInfo":"mo-z","reviewTypes":"no-z","expanded":"oo-z"};